import { c as _c } from "react/compiler-runtime";
import React, { type Dispatch, type SetStateAction } from 'react';
import Button from '@precis-digital/kurama/Button';
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import Divider from '@precis-digital/kurama/Divider';
import { styled } from '@precis-digital/kurama/utils';
import { StyledFlyoutFooter } from './styles';
import { useTranslation } from 'shared/translations';
import WorkspaceSwitcherList from '../WorkspaceSwitcherList';
import { APP_ROUTES } from 'shared/routes';
import { UnstyledLink } from 'shared/components/UnstyledLink';
interface SwitchWorkspaceProps {
  handleFlyout: Dispatch<SetStateAction<boolean>>;
}
const SwitchWorkspaceFlyout = t0 => {
  const $ = _c(16);
  const {
    handleFlyout
  } = t0;
  const {
    t
  } = useTranslation("workspace");
  let t1;
  if ($[0] !== t) {
    t1 = t("titles.switchWorkspace");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Typography variant="h2">{t1}</Typography>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleFlyout) {
    t3 = <WorkspaceSwitcherList onClientChange={() => {
      handleFlyout(false);
    }} />;
    $[4] = handleFlyout;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Grid height="16px" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("buttons.viewAllWorkspaces");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <StyledFlyoutFooter>{t5}<Button href={APP_ROUTES.workspace.listPage} LinkComponent={UnstyledLink} variant="filled" fullWidth={true}>{t6}</Button></StyledFlyoutFooter>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t7) {
    t8 = <StyledSwitchFlyout>{t2}{t3}{t4}{t7}</StyledSwitchFlyout>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
const StyledSwitchFlyout = styled(Grid)(() => ({
  paddingTop: '20px',
  paddingBottom: '48px',
  display: 'flex',
  flexDirection: 'column',
  form: {
    paddingTop: '20px',
    paddingBottom: '10px',
    '>div': {
      width: '100%'
    }
  }
}));
export default SwitchWorkspaceFlyout;